import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BasePage } from '../base.page';

@Component({
  selector: 'app-lawyers',
  templateUrl: './lawyers.component.html',
  styleUrls: ['./lawyers.component.scss']
})
export class LawyersComponent extends BasePage implements OnInit {

  constructor(protected route: ActivatedRoute, protected translate: TranslateService) {
    super(route, translate);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/lawyers/lawyers.component.ts